/* PrimeTime product gallery, size/variant selector and quantity controls.
   Runs alongside the built-in PrimeTime nav/search script. */
(() => {
  function setupGallery(gallery) {
    if (gallery.dataset.ptReady) return;
    gallery.dataset.ptReady = 'true';
    const main = gallery.querySelector('[data-pt-main-image]');
    const thumbnails = [...gallery.querySelectorAll('[data-pt-thumb]')];
    const counter = gallery.querySelector('[data-pt-image-count]');
    if (!main || !thumbnails.length) return;
    let current = thumbnails.findIndex((thumb) => thumb.classList.contains('is-active'));
    if (current < 0) current = 0;
    function show(index) {
      current = (index + thumbnails.length) % thumbnails.length;
      const thumb = thumbnails[current];
      main.src = thumb.dataset.src;
      main.alt = thumb.dataset.alt || main.alt;
      thumbnails.forEach((item, i) => {
        item.classList.toggle('is-active', i === current);
        item.setAttribute('aria-pressed', String(i === current));
      });
      if (counter) counter.textContent = `${current + 1} / ${thumbnails.length}`;
    }
    thumbnails.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
    gallery.querySelector('[data-pt-image-prev]')?.addEventListener('click', () => show(current - 1));
    gallery.querySelector('[data-pt-image-next]')?.addEventListener('click', () => show(current + 1));
    show(current);
    gallery.ptShowImage = (url) => {
      const index = thumbnails.findIndex((thumb) => thumb.dataset.src === url);
      if (index >= 0) show(index);
    };
  }
  function setupProduct(root) {
    if (root.dataset.ptReady) return;
    root.dataset.ptReady = 'true';
    const select = root.querySelector('[data-pt-variant-select]');
    const pills = [...root.querySelectorAll('[data-pt-variant-pill]')];
    const add = root.querySelector('[data-pt-add]');
    const addLabel = root.querySelector('[data-pt-add-label]');
    const dynamicCheckout = root.querySelector('.pt-payment-button');
    const price = root.querySelector('[data-pt-product-price]');
    const gallery = root.querySelector('[data-pt-gallery]');
    const qty = root.querySelector('[data-pt-quantity]');
    function syncVariant() {
      if (!select) return;
      const option = select.selectedOptions[0];
      if (!option) return;
      const available = option.dataset.available === 'true';
      if (price) price.textContent = option.dataset.price || price.textContent;
      if (add) add.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
      if (dynamicCheckout) dynamicCheckout.hidden = !available;
      pills.forEach((pill) => {
        const active = pill.dataset.variantId === option.value;
        pill.classList.toggle('is-active', active);
        pill.setAttribute('aria-pressed', String(active));
      });
      if (option.dataset.image && gallery?.ptShowImage) gallery.ptShowImage(option.dataset.image);
    }
    select?.addEventListener('change', () => {
      syncVariant();
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url);
    });
    pills.forEach((pill) => pill.addEventListener('click', () => {
      if (!select || pill.disabled) return;
      select.value = pill.dataset.variantId;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    root.querySelector('[data-pt-qty-minus]')?.addEventListener('click', () => {
      if (qty) qty.value = String(Math.max(1, (Number.parseInt(qty.value, 10) || 1) - 1));
    });
    root.querySelector('[data-pt-qty-plus]')?.addEventListener('click', () => {
      if (qty) qty.value = String((Number.parseInt(qty.value, 10) || 1) + 1);
    });
    syncVariant();
    if (pills.length) {
      select?.classList.add('pt-variant-select--pills');
      const pillGroup = root.querySelector('.pt-size-pills');
      if (pillGroup) pillGroup.hidden = false;
      root.classList.add('pt-product-ready');
      select?.setAttribute('tabindex', '-1');
    }
  }
  function init() {
    document.querySelectorAll('[data-pt-gallery]').forEach(setupGallery);
    document.querySelectorAll('[data-pt-product]').forEach(setupProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-pt-gallery]').forEach(setupGallery);
    event.target.querySelectorAll('[data-pt-product]').forEach(setupProduct);
  });
})();
